module.exports = __webpack_public_path__ + "img/red-packet-fill.318b9110.svg";